module.exports = __webpack_public_path__ + "img/USDC.7f7d18ba.svg";